import { Typography } from "@mui/material";
import { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 24px auto;
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  overflow: hidden; // Crucial para o efeito de recolher
  font-family: sans-serif;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  background-color: #f8f9fa;

  &:hover {
    background-color: #f1f3f5;
  }
`;

const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ToggleIcon = styled.span<{ isOpen: boolean }>`
  font-size: 1.5rem;
  transition: transform 0.3s ease-in-out;
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
`;

const AccordionBody = styled.div<{ isOpen: boolean }>`
  max-height: ${(props) =>
    props.isOpen ? "2000px" : "0px"}; // Altura máxima grande para caber tudo
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
`;

const FormContent = styled.div`
  padding: 24px;
`;

function AccordionWrapper({
  isOpen,
  header,
  headerBadge,
  children,
  setIsOpen,
}: {
  isOpen: boolean;
  header: string;
  headerBadge?: React.ReactNode;
  children: React.ReactNode;
  setIsOpen: (isOpen: boolean) => void;
}) {
  return (
    <Wrapper>
      <AccordionHeader onClick={() => setIsOpen(!isOpen)}>
        <HeaderTitleGroup>
          <Typography variant="h5" component="h2" fontWeight="bold">
            {header}
          </Typography>
          {!isOpen && headerBadge}
        </HeaderTitleGroup>
        <ToggleIcon isOpen={isOpen}>▼</ToggleIcon>
      </AccordionHeader>

      <AccordionBody isOpen={isOpen}>
        <FormContent>{children}</FormContent>
      </AccordionBody>
    </Wrapper>
  );
}

export default AccordionWrapper;
